import {
  NumericInput as BlueprintNumericInput,
  Intent,
} from '@blueprintjs/core';
import * as React from 'react';

import { XSD_INTEGER_IRI } from 'bones/constants/iris';

export interface NumericInputProps {
  disabled?: boolean;
  inputTestId?: string;
  intent?: Intent;
  onSetValue: (value: string) => void;
  placeholder?: string;
  range: string;
  testId?: string;
  value: string | null;
}

export const NumericInput: React.VFC<NumericInputProps> = ({
  disabled,
  inputTestId,
  intent,
  onSetValue,
  placeholder,
  range,
  testId,
  value,
}) => (
  <div className="sd-input-numeric" data-testid={testId}>
    <BlueprintNumericInput
      allowNumericCharactersOnly
      data-testid={inputTestId}
      disabled={disabled}
      intent={intent}
      minorStepSize={range === XSD_INTEGER_IRI ? null : 0.1}
      onValueChange={(_, stringValue) => onSetValue(stringValue)}
      placeholder={placeholder}
      value={value || ''}
    />
  </div>
);
